<template>
  <div class="fill-height container--fluid" style="width: 100%">
    <div class="container--fluid">
      <v-toolbar tile flat style="max-height: 38px">
        <v-btn icon v-on:click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title v-on:click="goBack" style="cursor: pointer">Go back</v-toolbar-title>
      </v-toolbar>
    </div>
    <v-container fluid class="mx-0 justify-start">
      <v-row align="start" justify="start">
        <v-col cols="12" md="3">
          <v-sheet class="mt-5">
            <v-card flat hover elevation="0" class="rounded-lg">
              <v-img v-if="profile.pictures[0] != null" :src="
                  profile.pictures != null
                    ? profile.pictures[0].url
                    : require('@/assets/images/no-image.jpg')
                " :lazy-src="require('@/assets/images/no-image.jpg')" position="top" contain height="300">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-card-title>
                <span class="indigo--text text-truncate">
                  {{
                  profile.name_english ? profile.name_english : profile.name
                  }}
                </span>
              </v-card-title>
              <v-card-text class="indigo--text">
                {{
                profile.description_english
                ? profile.description_english
                : profile.description
                }}
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>
        <v-col cols="12" md="9">
          <v-container fluid class="mx-0 justify-start">
            <v-row justify="start" align="start" dense>
              <v-col cols="12">
                <h1 class="text-h5 font-weight-regular headline text-uppercase">
                  Specialists
                </h1>
              </v-col>
              <v-col cols="12">
                <div class="boxdivider"></div>
              </v-col>
              <v-col cols="12" justify="center">
                <v-row justify-lg="start" justify-md="start" justify="center">
                  <SearchBar :data="doctors" @search="updateFilteredData" />
                  <FilterStateMunicipality @filter-data="filterEvent" />
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-container fluid class="fill-height justify-start px-0">
                  <v-row justify="start" align="start">
                    <v-col v-for="(item, index) in filterDoctors" :key="index" class="d-flex child-flex" col="12"
                      md="4">
                      <CardDoctor :item="item" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12">
                <v-row justify="center" class="ma-3" v-if="filterDoctors.length === 0 && !loading">
                  <div>No hay Especialistas en el cat&aacute;logos...</div>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <footer-profile-component />
  </div>
</template>

<script>
import specialtiesService from "@/providers/SpecialtiesService";
import doctorsService from "@/providers/DoctorsService";
import FooterProfileComponent from "@/layouts/app-layout/footer/FooterProfileComponent";
import { changeInformationSEO } from "@/providers/KeywordsServices";
import CardDoctor from "@/components/card-doctor/CardDoctor";
import FilterStateMunicipality from "@/components/filter-state-municipality/FilterStateMunicipality";
import SearchBar from "@/components/searchBar/SearchBar";
import {
  ADD_TO_ITINERARY_BUTTON,
  ADD_TO_ITINERARY,
  CALL_US,
  IM_INTEREST,
  LIKE,
  HOW_TO_GET_THERE,
  YOUTUBE_VIDEO,
  VISIT_PROFILE,
  PROFILE_NAME
} from "@/constant/speciality";
import { registerHistorial } from "@/providers/HistorialService";

export default {
  name: "SpecialtyProfileComponent",
  components: { 
    FooterProfileComponent,
    CardDoctor,
    FilterStateMunicipality,
    SearchBar
  },
  data: () => ({
    selection: -1,
    selectedId: 0,
    loading: true,
    model: null,
    doctors: [],
    filterDoctors: [],
    profile: {
      id: 0,
      name: null,
      name_english: null,
      description: null,
      description_english: null,
      pictures: [],
    },
  }),
  methods: {
    goBack() {
      this.$router.push("/specialties-services");
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    filterEvent(value) {
      this.getDoctors(value.province, value.municipality);
    },

    updateFilteredData(filteredData) {
      this.filterDoctors = filteredData;
    },

    getDoctors(city = '', municipality = '') {
      this.loading = true;

      doctorsService.getViewListSpecialty(this.unique, false, true, this.$route.params.id, city, municipality).then((record) => {
        this.doctors = [...record.value];
        this.filterDoctors = [...record.value];
      }).catch(err => console.log(err)).finally(() => {
        this.loading = false;
      });
    },
    getProfile(idSpecialty) {
      let record = null;
      specialtiesService.getRecord(idSpecialty).then((fetch_data) => {
        record = fetch_data.value;

        this.profile.id = record.id;
        this.profile.name = record.name;
        this.profile.name_english = record.name_english;
        this.profile.description = record.description;
        this.profile.description_english = record.description_english;
        this.profile.pictures = record.pictures;

        changeInformationSEO(record.keywords, record.description_english);
        this.toTop();
      });
    },
    showProfile(idDoctor) {
      this.selectedId = idDoctor;
      this.$router.push({
        name: "DoctorProfile",
        params: {
          id: idDoctor,
        },
      });
    },
    registerVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, VISIT_PROFILE);
    },
    registerYoutubeVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, YOUTUBE_VIDEO);
    },
    registerUbicationVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, HOW_TO_GET_THERE);
    },
    registerLikeVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, LIKE);
    },
    registerInterestVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, IM_INTEREST);
    },
    registerCallUSVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, CALL_US);
    },
    registerItineraryVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, ADD_TO_ITINERARY);
    },
    registerItineraryButtonVisit() {
      registerHistorial(this.$route.params.id, PROFILE_NAME, ADD_TO_ITINERARY_BUTTON);
    },
  },
  mounted() {
    this.getProfile(this.$route.params.id);
    this.registerVisit();
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
}
.boxdivider {
  background-color: transparent;
  width: 100%;
  height: 0px;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom-width: 3px;
  border-bottom-color: blueviolet;
  border-bottom-style: solid;
  display: block;
}
.superior-derecha {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 80px;
  height: 80px;
}
.superior-derecha-segunda {
  position: absolute;
  top: 60px;
  right: 3px;
  width: 95px;
  height: 95px;
}
.superior-derecha-tercera {
  position: absolute;
  top: 160px;
  right: 12px;
  width: 70px;
  height: 70px;
}
@media(max-width: 767px) {
  .superior-derecha {
    position: absolute;
    top: -13px;
    right: -13px;
    width: 40px;
    height: 40px;
  }

  .superior-derecha-segunda {
    position: absolute;
    top: 30px;
    right: 3px;
    width: 50px;
    height: 50px;
  }
  .superior-derecha-tercera {
    position: absolute;
    top: 90px;
    right: 7px;
    width: 37px;
    height: 37px;
  }
}
</style>
